import { useRouter } from '@capsicum/common-web';
import { useWCPledgeBasketState, wcPledgeBasketDataAtom } from '@capsicum/features/world-championship-pledge/shared';
import { useAtomValue } from 'jotai';

export const useStakeMore = () => {
	const router = useRouter();
	const basket = useAtomValue(wcPledgeBasketDataAtom);
	const { toggleBasketSelection } = useWCPledgeBasketState();

	const handleStakeMore = (teamId: string, ftName: string) => () => {
		const foundTeamId = basket.find(team => team.teamId === teamId);

		if (!foundTeamId) {
			toggleBasketSelection(teamId, ftName);
		}

		router.push('/locker-room-internationals/basket?focusedTeamId=' + teamId);
	};

	return {
		handleStakeMore
	};
};
